import type { Folder } from './Folder';
import type { IUser } from './User';

export enum RecordingTypes {
  dynamic = 'dynamic_recording',
  native = 'native_recording',
  overlay = 'live_demo',
  mobile = 'mobile_recording',
}

export enum RecordingPostprocessStateTypes {
  pending = 'pending',
  done = 'done',
  error = 'error',
}

export type IRecording = {
  status: string;
  createTime: string;
  creator: IUser;
  firstUrl: string;
  id: number | string;
  isDeleted: boolean;
  productId: number;
  recordName: string;
  revisionId: number;
  updateTime: string;
  screenshot: string;
  envName: string;
  snapshotId: number;
  image?: string;
  video?: string;
  title: string;
  slugName: string;
  revisionsCount?: number;
  description?: string;
  recorderUuid?: string;
  organizationId: string;
  recordingType: RecordingTypes;
  recordingToken?: string;
  playerToken?: string;
  totalDemos?: number;
  totalScreens?: number;
  archiveTime?: string;
  workspaceId: string;
  folderId?: Folder['id'];
  postprocessState?: RecordingPostprocessStateTypes;
};

export interface IRecordingPage {
  createDate: string;
  dataType: string;
  image: string;
  rowKey: string;
  title: string;
  url: string;
}

export interface RecorderHealthCheck {
  data: { status: string };
  endpointName: string;
  fulfilledTimeStamp: number;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isUninitialized: boolean;
  requestId: string;
  startedTimeStamp: number;
  status: string;
}

export type ClonedPageMetrics = {
  url: string;
  clicks: number;
  durationInSeconds: number;
};
